import { render } from "./SuggestionPanel.vue?vue&type=template&id=3a7e39ac&scoped=true"
import script from "./SuggestionPanel.vue?vue&type=script&lang=js"
export * from "./SuggestionPanel.vue?vue&type=script&lang=js"

import "./SuggestionPanel.vue?vue&type=style&index=0&id=3a7e39ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a7e39ac"]])

export default __exports__